import React from 'react';
import {string} from 'prop-types';
import cx from 'classnames';

import './Logo.css';

const propTypes = {
  className : string
};

const defaultProps = {
  className : ''
}

function Logo(props) {
  const {className} = props;

  return (
    <i className={cx('logo', className)} />
  );
}

Logo.propTypes = propTypes;
Logo.defaultProps = defaultProps;

export default Logo;
